import displayLicenseDialogTemplate from "./DisplayLicenseDialog.html";

/*****************************************************************************************
 * Dialog displays EULA agreement and asks user to accept. Sends selected option to server.
 *****************************************************************************************/
/* @ngInject */ export function DisplayLicenseDialogService($uibModal) {
  this.show = function () {
    var dialog = $uibModal.open({
      animation: true,
      template: displayLicenseDialogTemplate,
      controller: controller,
      controllerAs: '$ctrl',
      size: 'lg',
      backdrop: 'static',
      windowClass: 'eula-modal-popup'
    });

    return dialog.result;
  };
}

/***************************************************************************
 * Controller
 ***************************************************************************/
/* @ngInject */ function controller($uibModalInstance, CommonSvc) {
  var $ctrl = this;

  $ctrl.accept = function () {
    CommonSvc.acceptLicense().then(function () {
      $uibModalInstance.close();
    });
  };

  $ctrl.decline = function () {
    $uibModalInstance.dismiss('Dismiss/Reject');
  };
}
